import { useIsPaymentsApproved } from 'growth-payments-core/hooks/useIsPaymentsApproved';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export const useObjectTypeForZeroState = configReport => {
  const isPaymentsApproved = useIsPaymentsApproved();
  let objectTypeId = configReport.getIn(['config', 'objectTypeId']);
  if (objectTypeId === COMMERCE_PAYMENT_TYPE_ID && !isPaymentsApproved) {
    objectTypeId = 'setUpPayments';
  }
  return objectTypeId;
};